"use client";

import styles from './wpforms.module.css';
import customStyles from './wp-form391.module.css';
import Image from "next/image";
import WpField from "./wp-field";
import {useActionState, useEffect, useRef} from "react";
import {Link} from "@pata/i18n";
import {useTranslations} from "next-intl";

export type State = {
    errors?: {
        name?: string[],
        email?: string[],
        phone?: string[],
        cadastralNr?: string[],
        question?: string[],
        consent?: string[],
    };
    message?: string,
    success?: boolean,
    data?: {
        name: FormDataEntryValue | null,
        email: FormDataEntryValue | null,
        phone: FormDataEntryValue | null,
        cadastralNr: FormDataEntryValue | null,
        question: FormDataEntryValue | null,
        consent: FormDataEntryValue | boolean | null,
    }
}

export type Props<T> = {
    action: (state: Awaited<T>, formData: FormData) => T | Promise<T>,
    initialState: T,
    placeholders?: {
        question?: string;
        name?: string;
        email?: string;
        phone?: string;
        cadastralNr?: string;
    }
}

const scrollOpts: ScrollIntoViewOptions = {
    behavior: "smooth",
    block: "start",
    inline: "start"
}

export default function WpForm391(props: Props<State>) {
    const [state, formAction, pending] = useActionState(props.action, props.initialState)
    const t = useTranslations('SectionContactForm')
    const successRef = useRef<HTMLDivElement>(null)
    
    useEffect(() => {
        if (!successRef.current) return;
        if (state.success) {
            successRef.current.scrollIntoView(scrollOpts)
        }
    }, [state, successRef])
    
    return (
        <div className={`${styles["wpforms-container"]} ${styles["wpforms-container-full"]}`}
             id="wpforms-391" style={{opacity: pending ? 0.6 : 1}}
        >
            {!state.success
                ? (
                    <form id="wpforms-form-391"
                          className={`${styles["wpforms-validate"]} ${styles["wpforms-form"]} ${styles["wpforms-ajax-form"]}`}
                          data-formid="391" action={formAction}
                          data-token="9db4116ed88e02a95569b7b920be50a0" noValidate={true}>
                        <noscript className={styles["wpforms-error-noscript"]}>Please enable JavaScript in your browser to complete this form.</noscript>
                        
                        <div className="wpforms-field-container">
                            <WpField title={t('fullName')} required={true} id={1} type={'input'} classes={{container: customStyles["wpforms-field"]}}
                                     placeholder={""} error={state.errors?.name} value={state.data?.name} formId={391} />
                            <WpField title={t('email')} required={true} id={2} type={'input'} classes={{container: customStyles["wpforms-field"]}}
                                     placeholder={""} error={state.errors?.email} value={state.data?.email} formId={391} />
                            <WpField title={t('phoneNumber')} required={true} id={3} type={'input'} classes={{container: customStyles["wpforms-field"]}}
                                     placeholder={""} error={state.errors?.phone} value={state.data?.phone} formId={391} />
                            <WpField title={t('assetNr')} required={false} id={4} type={'input'} classes={{container: customStyles["wpforms-field"]}}
                                     placeholder={""} error={state.errors?.cadastralNr} value={state.data?.cadastralNr} formId={391} />
                            <WpField title={t('information')} required={false} id={5} type={'textarea'}
                                     classes={{container: `${customStyles["wpforms-field"]}`, element: `${customStyles["wpforms-field-medium"]}`}}
                                     placeholder={""} error={state.errors?.question} value={state.data?.question} formId={391} />
                            
                            <div id="wpforms-391-field_6-container" className={`${styles["wpforms-field"]} ${customStyles["wpforms-field"]}`} data-field-id="6">
                                <ul id="wpforms-391-field_6" className={styles["wpforms-field-required"]}>
                                    <li className={`${styles["choice-1"]} ${styles["depth-1"]}`}>
                                        <input type="checkbox" id="wpforms-391-field_6_1" name="wpforms[fields][6][]" defaultChecked={!!state.data?.consent} />
                                        <label className={styles["wpforms-field-label-inline"]} htmlFor="wpforms-391-field_6_1"> </label>
                                    </li>
                                </ul>
                                <div className={`${styles["wpforms-field-description"]} ${customStyles["wpforms-field-description"]}`}>
                                    {t.rich('acceptTermsAndServices', {
                                        privacyPolicyLink: (chunks) => <Link href="/privacy-policy">{chunks}</Link>
                                    })}
                                </div>
                                {state.errors?.consent && (<label id="wpforms[fields][6][]-error" className={styles["wpforms-error"]} htmlFor="wpforms[fields][6][]" dangerouslySetInnerHTML={{ __html: state.errors?.consent.join("<br>") }}></label>)}
                            </div>
                        </div>
                
                        <div className={styles["wpforms-submit-container"]}>
                            <input type="hidden" name="wpforms[id]" value="391" />
                            <input type="hidden" name="wpforms[author]" value="0"/>
                            <input type="hidden" name="wpforms[post_id]" value="14"/>
                            
                            <button type="submit" name="wpforms[submit]" id="wpforms-submit-391"
                                className={styles["wpforms-submit"]} data-alt-text="Sending..."
                                data-submit-text="{t('submitButton')}" aria-live="assertive"
                                value="wpforms-submit">
                                {t('submitButton')}
                            </button>
                            
                            <Image src="/img/submit-spin.svg" className={styles["wpforms-submit-spinner"]}
                               style={{display: (pending ? "block" : "none")}} width="26" height="26" alt=""/>
                        </div>
                    </form>
                )
                : (
                    <div className={`${styles["wpforms-confirmation-container-full"]} ${styles["wpforms-confirmation-scroll"]}`} id="wpforms-confirmation-391" ref={successRef}>
                        <p>{state.message}</p>
                    </div>
                )
            }
        </div>
    )
}